import dayjs from "dayjs";
import { getDivisionChoices } from "../cclib/CCUtility.ts";
import {
  ConferenceStructure,
  laheyCCManage,
  laheyCCSetup,
  overrideStructure
} from "./lah_helper.js";

const dataPrefix = "lah_";
let sortBy = "mentor";

export default {
  title: "Lahey Radiology",
  tabTitle: "Annual Performance Evaluation",
  cvSetup: function ({
    contextMethods,
    contextConstants,
    contextState,
    conference,
    backend
  }) {
    const { hierarchy, hierarchyNames } = contextConstants;
    let choices = getDivisionChoices(conference, hierarchy, hierarchyNames);

    const structure = new ConferenceStructure(choices);
    overrideStructure(structure);

    laheyCCSetup(
      contextMethods,
      contextConstants,
      contextState,
      conference,
      backend,
      dataPrefix,
      "lahey_radiology_staff_report_v1_0.docx",
      "Lahey Radiology Review Form",
      "301155080",
      // Function here is what is called when generating output data.
      function generateOutputData(data, elementArray, props) {
        const {
          departmentName,
          departmentId,
          appraiserName,
          appraisalPeriod,
          yearData,
          lastYearData,
          startDate,
          newDef
        } = props;
        data["department_name"] = departmentName;
        data["department_id"] = departmentId;
        data["appraiser_name"] = appraiserName;
        data["appraisal_period"] = appraisalPeriod;
        data["date_appraisal_completed"] = yearData?.data?.chairSign
          ? dayjs(yearData?.data?.chairSign.time).format("M/D/YYYY")
          : "";
        data["appraiser_signature"] =
          yearData?.data?.chairSign?.signature || "";
        data["appraiser_signed_at"] = dayjs(
          yearData?.data?.chairSign?.time || ""
        ).format("M/D/YYYY");
        data["colleague_signature"] =
          yearData?.data?.menteeSign?.signature || "";
        data["colleague_signed_at"] = dayjs(
          yearData?.data?.menteeSign?.time || ""
        ).format("M/D/YYYY");
        data["current_year"] = dayjs(startDate).format("YYYY");
        data["prior_year"] = dayjs(startDate)
          .subtract(1, "year")
          .format("YYYY");
        elementArray.map(function (item) {
          if (item.key != null) {
            if (item.type == "check")
              data[item.key] = !!yearData.data[dataPrefix + item.key];
            else if (item.type == "extraction")
              data[item.key] = item.val(newDef).text;
            else if (item.type == "previous")
              data[item.key] =
                lastYearData.data[dataPrefix + item.key.replace("_prev", "")] ||
                "";
            else data[item.key] = yearData.data[dataPrefix + item.key] || "";
          } else if (item.type == "table" || item.type == "inline-table") {
            generateOutputData(data, item.sections, props);
          }
        });
        if (yearData?.data?.[dataPrefix + "lahey_start_date"] != undefined) {
          data["years_at_lahey"] = dayjs()
            .diff(
              dayjs(yearData.data[dataPrefix + "lahey_start_date"]),
              "year",
              true
            )
            .toFixed(1);
        }
        if (yearData?.data?.[dataPrefix + "job_start_date"] != undefined) {
          data["years_in_job"] = dayjs()
            .diff(
              dayjs(yearData.data[dataPrefix + "job_start_date"]),
              "year",
              true
            )
            .toFixed(2);
        }
        if (
          yearData?.data?.[dataPrefix + "secondary_job_start_date"] != undefined
        ) {
          data["years_in_secondary_job"] = dayjs()
            .diff(
              dayjs(yearData.data[dataPrefix + "secondary_job_start_date"]),
              "year",
              true
            )
            .toFixed(2);
        }
      }
    );
  },
  // This is for setting up the Manage Departments page
  manageSetup: function (
    settingsEl,
    { conference, updateConfDate, saveConference, hierarchyNames, backend },
    user
  ) {
    laheyCCManage(
      settingsEl,
      conference,
      updateConfDate,
      saveConference,
      hierarchyNames,
      backend,
      user
    );
  }
};
